import React, { PropTypes } from 'react';
import { canUseDOM } from 'react/lib/ExecutionEnvironment';
import PureComponent from 'components/PureComponent';
import { Link } from 'react-router';
import Button from 'components/Button';
import BuyButton from 'components/BuyButton';
import Drawer from 'components/Drawer';
import Socials from 'components/Socials';

import MenuItem from './MenuItem';

import baikalsea from './baikalsea.png';

const items = {
  '/': 'Байкал430',
  '/original': 'Уникальность воды',
  '/source': 'Где добывается',
  // '/journey': 'Путешествие на Байкал',
  '/faq': 'Задать вопрос'
};

class Menu extends PureComponent {
  static contextTypes = {
    deviceType: PropTypes.string
  };

  handleItemClick() {
    if (canUseDOM) {
      window.scrollTo(0, 0);
    }

    this.props.onClose();
  }

  render() {
    require('./Menu.styl');
    const { deviceType } = this.context;
    const drawerProps = {
      position: 'right',
      size: deviceType === 'mobile' ? '100vw' : '355',
      isOpen: this.props.isOpen,
      onClose: this.props.onClose
    };

    return (
      <Drawer {...drawerProps}>
        <div className="Menu">
          <div className="Menu__top">
            <ul className="Menu__list">
              {Object.keys(items).map((url, i) => (
                <MenuItem
                  key={i}
                  url={url}
                  onClick={this.handleItemClick.bind(this)}
                >
                  <span dangerouslySetInnerHTML={{ __html: items[url] }} />
                </MenuItem>
              ))}
            </ul>
            {/* <Link to="/form">
              <Button>Ввести код</Button>
            </Link>
            <BuyButton
              isSimple={true}
              style={{
                color: '#fff',
                borderColor: '#21c8ff',
                backgroundColor: '#21c8ff',
                marginLeft: 20,
                lineHeight: '34px',
                width: 86
              }}
            /> */}
            {/*<Button*/}
            {/*component="a"*/}
            {/*href="http://www.waterbaikal.ru/baikalwater/voda-baikalwater-0.45-litra.html"*/}
            {/*target="_blank"*/}
            {/*style={{*/}
            {/*color: '#fff',*/}
            {/*borderColor: '#21c8ff',*/}
            {/*backgroundColor: '#21c8ff',*/}
            {/*marginLeft: 20,*/}
            {/*lineHeight: '34px',*/}
            {/*width: 86,*/}
            {/*}}*/}
            {/*>*/}
            {/*<span style={{ verticalAlign: 'middle', display: 'inline-block' }}>*/}
            {/*Купить*/}
            {/*</span>*/}
            {/*</Button>*/}
          </div>

          <div className="Menu__footer">
            <div className="Menu__footer-sea">
              <p>Мы&nbsp;заботимся о&nbsp;Вашем здоровье, доставляя Вам чистейшую байкальскую воду и&nbsp;сохраняя озеро Байкал</p>
              <a href="https://baikal-sea.com" target="_blank">
                <img src={baikalsea} alt="Baikalsea Company" width="100" />
              </a>
            </div>
            <div style={{ marginBottom: 32 }}>
              <Socials />
            </div>
          </div>
        </div>
      </Drawer>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js